module.exports = __webpack_public_path__ + "img/no-data.1b1aa64a.png";